import { ref } from 'vue'
import {
  applicationApi,
  serviceApi,
  agencyApi,
  positionDecisionMakerApi,
  counterpartyApi
} from '../services/api.js'

const apiServices = {
  application: applicationApi,
  service: serviceApi,
  agency: agencyApi,
  position_decision_maker: positionDecisionMakerApi,
  counterparty: counterpartyApi
}

const responseKeys = {
  application: 'applications',
  service: 'services',
  agency: 'agencies',
  position_decision_maker: 'position_decision_makers',
  counterparty: 'counterparties'
}

export function useEntity(entityType) {
  const apiService = apiServices[entityType]
  const responseKey = responseKeys[entityType]

  if (!apiService || !responseKey) {
    throw new Error(`Unsupported entity type: ${entityType}`)
  }

  const entities = ref([])
  const totalCount = ref(0)
  const loading = ref(false)
  const submitting = ref(false)

  const modalMode = ref('create')
  const selectedEntity = ref({})

  const fetchEntities = async () => {
    if (loading.value) return
    loading.value = true
    try {
      const response = await apiService.getList()
      if (response && response[responseKey]) {
        entities.value = response[responseKey]
        totalCount.value = response.total_count || response[responseKey].length
      } else {
        entities.value = []
        totalCount.value = 0
      }
    } catch {
      entities.value = []
      totalCount.value = 0
    } finally {
      loading.value = false
    }
  }

  const createEntity = async data => {
    submitting.value = true
    try {
      console.log('createEntity - отправляемые данные:', data)
      const response = await apiService.create(data)
      if (response && response.id) {
        entities.value.push(response)
        totalCount.value += 1
      }
      return response
    } catch {
      return null
    } finally {
      submitting.value = false
    }
  }

  const updateEntity = async (id, data) => {
    submitting.value = true
    try {
      console.log('updateEntity - отправляемые данные:', data)
      const response = await apiService.update(id, data)
      const index = entities.value.findIndex(entity => entity.id === id)
      if (index !== -1 && response) {
        entities.value[index] = { ...entities.value[index], ...response }
      }
      return response
    } catch {
      return null
    } finally {
      submitting.value = false
    }
  }

  const deleteEntity = async id => {
    submitting.value = true
    try {
      const response = await apiService.delete(id)
      const index = entities.value.findIndex(entity => entity.id === id)
      if (index !== -1) {
        entities.value.splice(index, 1)
        totalCount.value -= 1
      }
      return response
    } catch {
      return null
    } finally {
      submitting.value = false
    }
  }

  const getEntityById = async id => {
    try {
      return await apiService.getById(id)
    } catch {
      return null
    }
  }

  const openCreateModal = () => {
    modalMode.value = 'create'
    selectedEntity.value = {}
  }

  const openEditModal = entity => {
    modalMode.value = 'edit'
    selectedEntity.value = { ...entity }
  }

  const handleSubmit = async formData => {
    try {
      let response
      if (modalMode.value === 'create') {
        response = await createEntity(formData)
      } else {
        response = await updateEntity(selectedEntity.value.id, formData)
      }
      return response
    } catch (err) {
      throw err
    }
  }

  return {
    entities,
    totalCount,
    loading,
    submitting,
    modalMode,
    selectedEntity,
    fetchEntities,
    createEntity,
    updateEntity,
    deleteEntity,
    getEntityById,
    openCreateModal,
    openEditModal,
    handleSubmit
  }
}
